"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function camelizeString(str, delimiter) {
  delimiter = typeof delimiter !== 'undefined' ? delimiter : '_';
  return str.split(delimiter).reverse().reduce(function (a, val, index) {
    var next = index === 0 ? a : a.replace(/^./, a.charAt(0).toUpperCase());
    return "".concat(val).concat(next);
  }, '');
}

function camelizeObject(o, delimiter) {
  delimiter = typeof delimiter !== 'undefined' ? delimiter : '_';
  var r = {};
  Object.keys(o).forEach(function (key) {
    var camelizedKey = camelizeString(key, delimiter);
    r[camelizedKey] = r[camelizedKey] || o[key];
  });
  return r;
}

function decamelizeString(str, delimiter) {
  delimiter = typeof delimiter !== 'undefined' ? delimiter : '_';
  return str.replace(/[A-Z]/g, function (m) {
    return "".concat(delimiter).concat(m.toLowerCase());
  });
}

function decamelizeObject(o, delimiter) {
  delimiter = typeof delimiter !== 'undefined' ? delimiter : '_';
  var r = {};
  Object.keys(o).forEach(function (key) {
    var decamelizedKey = decamelizeString(key, delimiter);
    r[decamelizedKey] = r[decamelizedKey] || o[key];
  });
  return r;
}

function slugify(str) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return str.replace(/[^a-zA-Z0-9]/gi, delimiter);
}

function removeBracketAndDotNotation(str) {
  var dotDelimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return str.replace(/\[.*\]/ig, '').replace(/\./, dotDelimiter);
}

var GUIDRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;

function isGUID() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return GUIDRegex.test(str);
}

function generateRandomAlphaNumeric() {
  var targetLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  var pieces = [];
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  while (pieces.length < targetLength) {
    pieces.push(possible.charAt(Math.floor(Math.random() * possible.length)));
  }

  return pieces.join('');
}

function safeJSONParse(message) {
  try {
    message = JSON.parse(message);
  } catch (_) {}

  return message;
}

function safeJSONStringify(obj) {
  if (_typeof(obj) === 'object') {
    return JSON.stringify(obj);
  }

  return obj;
}

module.exports = {
  camelizeString: camelizeString,
  camelizeObject: camelizeObject,
  decamelizeString: decamelizeString,
  decamelizeObject: decamelizeObject,
  slugify: slugify,
  removeBracketAndDotNotation: removeBracketAndDotNotation,
  GUIDRegex: GUIDRegex,
  isGUID: isGUID,
  generateRandomAlphaNumeric: generateRandomAlphaNumeric,
  safeJSONParse: safeJSONParse,
  safeJSONStringify: safeJSONStringify
};